<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import SettingsCategory from "./SettingsCategory.vue";
import InstallAppButton from "@/components/pwa/InstallAppButton.vue";
import { useInstallPrompt } from "@/composable/useInstallPrompt";

const { t } = useTranslation();

// L'app n'est proposée à l'installation que si elle ne l'est pas déjà.
const { canOfferInstall } = useInstallPrompt();
</script>

<template>
  <SettingsCategory
    v-if="canOfferInstall"
    :title="t('dashboard:settings.category.application.title')"
  >
    <p class="install-section__desc">{{ t("install.description") }}</p>
    <div>
      <InstallAppButton size="sm" />
    </div>
  </SettingsCategory>
</template>

<style lang="scss" scoped>
.install-section__desc {
  margin: 0;
  font-size: 0.8rem;
  color: var(--bs-secondary-color);
}
</style>
